module.exports = __webpack_public_path__ + "img/bgBox_pc.9ef5cf67.jpg";